export default "__VITE_ASSET__V0gpro6I__"